<template>
  <div id="production-task">
    <template v-if="showPage == 1">
      <el-card class="search-input-wrap table_searchbar">
        <el-row class="search-input-row" style="margin-bottom: 20px">
          <el-col :span="5">
            <div @keydown.enter="clickSearch()">
              <span class="title">工单号：</span>
              <el-input style="max-width: 180px" size="small" v-model="searchForm.productionBatchCode"
                placeholder="工单号"></el-input>
            </div>
          </el-col>

          <el-col :span="5">
            <div>
              <span class="title">物料编码：</span>
              <el-input style="max-width: 180px" size="small" v-model="searchForm.materialCode"
                placeholder="物料编码"></el-input>
            </div>
          </el-col>

          <el-col :span="5">
            <div @keydown.enter="clickSearch()">
              <span class="title">物料名称：</span>
              <el-input style="max-width: 180px" size="small" v-model="searchForm.materialName"
                placeholder="物料名称"></el-input>
            </div>
          </el-col>

          <el-col :span="5">
            <div @keydown.enter="clickSearch()">
              <span class="title">订单号：</span>
              <el-input style="max-width: 180px" size="small" v-model="searchForm.erpBusinessOrderCode"
                placeholder="订单号"></el-input>
            </div>
          </el-col>
          <el-col :span="4">
            <div style="text-align: right">
              <a style="margin-right: 12px; cursor: pointer; font-size: 12px" @click="toggleShowMore">
                {{ showMore ? "收起" : "展开" }}
                <i :class="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
              </a>
              <el-button type="primary" icon="el-icon-search" size="mini" @click="clickSearch">查询</el-button>
              <el-button size="mini" icon="el-icon-refresh" @click="clearSearch">重置</el-button>
            </div>
          </el-col>
        </el-row>
        <el-collapse-transition>
          <div v-show="showMore">
            <el-row class="search-input-row" style="margin-bottom: 20px; margin-top: 20px">
              <el-col :span="5">
                <div>
                  <span class="title">工单类型：</span>
                  <el-select clearable style="max-width: 180px" filterable v-model="searchForm.splitPlanType"
                    size="small" maxlength="16" placeholder="工单类型" @keyup.enter.native="search">
                    <el-option v-for="item in orderTypeOptions" :key="item.id" :value="item.value"
                      :label="item.label"></el-option>
                  </el-select>
                </div>
              </el-col>

              <el-col :span="5">
                <div>
                  <span class="title" style="width: 112px; margin-left: -34px">计划完工时间：</span>
                  <el-date-picker style="width: 230px" v-model="searchForm.daterange" type="daterange"
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"></el-date-picker>
                </div>
              </el-col>

              <el-col :span="5">
                <div>
                  <span class="title">工单状态：</span>
                  <el-select clearable style="max-width: 180px" multiple collapse-tags filterable
                    v-model="searchForm.splitStatus" size="small" maxlength="16" placeholder="工单状态"
                    @keyup.enter.native="search">
                    <el-option v-for="item in orderStatusOptions" :key="item.id" :value="item.value"
                      :label="item.label"></el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="5">
                <div>
                  <span class="title">机组：</span>
                  <el-select clearable style="max-width: 180px" multiple collapse-tags filterable
                    v-model="searchForm.factoryModelId" size="small" maxlength="16" placeholder="机组"
                    @keyup.enter.native="search">
                    <el-option v-for="item in workershopList" :key="item.id" :value="item.id"
                      :label="item.name"></el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>
            <el-row class="search-input-row" style="margin-bottom: 20px">
              <el-col :span="5">
                <div>
                  <span class="title">客户：</span>
                  <el-select clearable filterable v-model="searchForm.customerId" remote placeholder="请选择"
                    style="max-width: 180px" clearable>
                    <el-option v-for="item in customList" :key="item.id"
                      :label="item.customerCode + ' | ' + item.customerName" :value="item.id"></el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="5">
                <div>
                  <span class="title">规格：</span>
                  <el-input style="max-width: 180px" size="small" v-model="searchForm.specification"
                    placeholder="规格"></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-collapse-transition>
      </el-card>
      <el-card class="table-card">
        <div class="table_common_operbar" style="margin-bottom: 20px">
          <el-row>
            <el-button v-if="permission.btn_productionTask_order" type="primary" size="mini"
              @click="showScheduling">生产排程</el-button>
            <el-button v-if="permission.btn_productionTask_update_info" type="primary" size="mini"
              @click="refreshList">更新数据</el-button>
            <el-button v-if="permission.btn_production_cost" type="primary" size="mini"
              @click="showMaterialConfig">原料配置</el-button>
            <el-button v-if="permission.btn_team_shift" type="primary" size="mini"
              @click="showWorkshopShiftConfig">班组交接班数据录入</el-button>
          </el-row>
        </div>
        <el-row class="table">
          <el-row class="table-wrap" v-if="viewType == 1">
            <el-table :data="tableData" @cell-click="cellClick" @header-dragend="headerColWidthChange"
              :cell-style="cellStyle" border ref="tableDataRef" @sort-change="sortChangeEvent"
              @selection-change="handleSelectionChange">
              <el-table-column fixed type="selection" width="55"> </el-table-column>
              <el-table-column key="2" v-if="selectTableColumns.includes('productionBatchCode')"
                prop="productionBatchCode" :width="computedColWidth('productionBatchCode', 185)" label="工单号"
                show-overflow-tooltip fixed>
                <template slot-scope="scope">
                  {{
                    scope.row.childProductionBatchCode
                      ? scope.row.childProductionBatchCode
                      : scope.row.productionBatchCode
                  }}
                  <img v-if="scope.row.productionType === 1" style="width: 12px; height: 12px; margin-right: 2px"
                    src="/static/img/jiaji.png" alt="" />
                </template>
              </el-table-column>

              <el-table-column key="77" v-if="selectTableColumns.includes('customerName')" prop="customerName"
                label="客户名称" :width="computedColWidth('customerName', 70)" show-overflow-tooltip></el-table-column>
              <el-table-column key="6" v-if="selectTableColumns.includes('materialCode')" prop="materialCode"
                label="物料编码" :width="computedColWidth('materialCode', 155)" show-overflow-tooltip></el-table-column>
              <el-table-column key="5" v-if="selectTableColumns.includes('materialName')" prop="materialName"
                label="物料名称" :width="computedColWidth('materialName', 155)" show-overflow-tooltip></el-table-column>
              <!-- <el-table-column
                key="61"
                v-if="selectTableColumns.includes('materialQualityName')"
                prop="materialQualityName"
                label="材质"
                :width="computedColWidth('materialQualityName', 100)"
                show-overflow-tooltip
              ></el-table-column> -->
              <el-table-column key="7" v-if="selectTableColumns.includes('specification')" prop="specification"
                label="规格型号" :width="computedColWidth('specification', 130)" show-overflow-tooltip></el-table-column>

              <el-table-column prop="rollLength" label="卷长" show-overflow-tooltip></el-table-column>

              <el-table-column key="8" v-if="selectTableColumns.includes('splitCount')" prop="splitCount" label="计划数量"
                :width="computedColWidth('splitCount', 100)" show-overflow-tooltip></el-table-column>
              <el-table-column key="88" v-if="selectTableColumns.includes('auxQty')" prop="auxQty" label="件数"
                :width="computedColWidth('auxQty', 70)" show-overflow-tooltip></el-table-column>
              <el-table-column key="3" v-if="selectTableColumns.includes('productionCodeParent')"
                prop="productionCodeParent" sortable="custom" label="生产任务单号"
                :width="computedColWidth('productionCodeParent', 110)" show-overflow-tooltip></el-table-column>

              <el-table-column key="4" v-if="selectTableColumns.includes('seqNo')" prop="seqNo" label="行号"
                :width="computedColWidth('seqNo', 110)" show-overflow-tooltip></el-table-column>
              <el-table-column key="33" v-if="selectTableColumns.includes('erpBusinessOrderCode')"
                prop="erpBusinessOrderCode" sortable="custom" label="订单号"
                :width="computedColWidth('erpBusinessOrderCode', 110)" show-overflow-tooltip></el-table-column>
              <el-table-column key="11" v-if="selectTableColumns.includes('planStartTime')" sortable="custom"
                prop="planStartTime" label="计划开始时间" :formatter="(row) => parseDate(row.planStartTime)"
                :width="computedColWidth('planStartTime', 138)">
              </el-table-column>

              <el-table-column key="12" v-if="selectTableColumns.includes('planEndTime')" prop="planEndTime"
                label="计划完工时间" :formatter="(row) => parseDate(row.planEndTime)"
                :width="computedColWidth('planEndTime', 138)">
              </el-table-column>
              <el-table-column key="12" prop="startProductTime" label="实际开始生产时间"
                :width="computedColWidth('startProductTime', 208)">
              </el-table-column>
              <el-table-column key="12" prop="finishBusTime" label="完成全部母卷时间"
                :width="computedColWidth('finishBusTime', 208)">
              </el-table-column>
              <el-table-column key="12" prop="finishedTime" label="订单完成时间"
                :width="computedColWidth('finishedTime', 208)">
              </el-table-column>
              <el-table-column key="9" v-if="selectTableColumns.includes('workshopName')" prop="factoryModelName"
                sortable="custom" label="机组" :width="computedColWidth('workshopName', 50)" show-overflow-tooltip>
              </el-table-column>
              <el-table-column key="13" v-if="selectTableColumns.includes('splitStatus')" sortable="custom"
                prop="splitStatus" label="工单状态" fixed="right" :width="computedColWidth('splitStatus', 140)"
                show-overflow-tooltip>
                <template slot-scope="scope" v-if="selectTableColumns.includes('splitStatus')">
                  <span class="radius" :style="parseStatus(scope.row).radiusStyle"></span>
                  <span :style="parseStatus(scope.row).textStye">{{
                    parseStatus(scope.row).text
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column key="17" v-if="selectTableColumns.includes('productionState')" prop="productionState"
                label="工单生产状态" :width="computedColWidth('productionState', 80)" show-overflow-tooltip
                :formatter="parseProductionState"></el-table-column>

              <el-table-column key="20" label="操作" prop="action1" :width="computedColWidth('action1', 340)"
                fixed="right">
                <template #header>
                  <span style="position: relative; top: -5px">操作</span>
                  <!-- <i @click="changeViewType(1)" class="el-icon-s-fold tab-icon" v-show="viewType==2"></i> -->
                  <!-- <i @click="changeViewType(2)" class="el-icon-menu tab-icon" v-show="viewType == 1"></i> -->
                </template>
                <template slot-scope="scope">
                  <el-button v-if="permission.btn_productionTask_update" @click="showEditTask(scope.row)" type="text"
                    size="small">编辑</el-button>

                  <!-- <el-button v-if="showStartProduction(scope.row)" @click="startProduction(scope.row)" type="text" size="small">计划下达</el-button> -->

                  <el-button v-if="
                    scope.row.splitStatus == 5 && permission.btn_productionTask_restart
                  " @click="cancelCloseProductionPlan(scope.row)" type="text" size="small">取消关闭</el-button>
                  <el-button v-if="permission.btn_productionTask_technologyParams" @click="showBom(scope.row)"
                    type="text" size="small">实时工艺参数</el-button>
                  <el-button :disabled="!permission.btn_qcTask_addQcTask ||
                    !['2', '3', '4'].includes(scope.row.productionState)
                    " @click="toQuality(scope.row)" type="text" size="small">质检</el-button>
                  <el-button v-if="
                    permission.btn_qcScheme_addQcScheme &&
                    permission.btn_qcScheme_updateQcScheme
                  " @click="toQualityPrint(scope.row)" type="text" size="small">质检方案</el-button>
                  <el-button v-if="
                    permission.btn_order_operating_record
                  " @click="orderOperatorHistoryDialog = true; currentRow = scope.row" type="text"
                    size="small">订单操作记录</el-button>
                  <el-button v-if="
                    permission.btn_productionTask_cancel &&
                    scope.row.productionState == 1
                  " @click="cancel(scope.row)" type="text" size="small">取消</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <div class="page" v-if="page.isShow" :style="{ marginBottom: viewType == 1 ? '10px' : '20px' }">
            <div class="total_page">
              <span> 共{{ page.total }}条 {{ page.pageSize }}条/页</span>
            </div>
            <div style="margin-top: 10px; text-align: right; margin-bottom: 10px">
              <el-pagination :page-size="page.pageSize" background layout="prev, pager, next" :total="page.total"
                @current-change="pageChange" :current-page.sync="page.currentPage"></el-pagination>
            </div>
          </div>
        </el-row>
      </el-card>
      <!--BOM清单-->
      <el-dialog title="实时工艺参数" :visible.sync="bomDialog" center>
        <el-table :data="bomData" max-height="600px">
          <el-table-column prop="parameterName" label="工艺参数名称" min-width="140" show-overflow-tooltip></el-table-column>
          <el-table-column prop="parameterValue" label="参数值" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="currentValue" label="实时值" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="lowerLimit" label="下限值" min-width="70"></el-table-column>
          <el-table-column prop="upperLimit" label="上限值" min-width="70" show-overflow-tooltip></el-table-column>
        </el-table>
        <div style="text-align: center; margin-top: 20px">
          <el-button size="small" @click="bomDialog = false" style="margin-left: 20px">关闭</el-button>
        </div>
      </el-dialog>
      <!--工艺查看（工价修改）-->
      <el-dialog title="查看" :visible.sync="technologyDialog">
        <el-table :data="technologyData">
          <el-table-column type="index" width="80px" label="序号"></el-table-column>
          <el-table-column label="工序编码" prop="procedureCode"></el-table-column>
          <el-table-column label="工序名称" prop="procedureName"></el-table-column>
          <el-table-column label="工价（元）">
            <template slot-scope="scope">
              <el-input :disabled="selectStatus == 6" v-model="scope.row.everySalary" maxlength="8"
                onkeyup="this.value=this.value.match(/\d+\.?\d{0,4}/)"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center; margin-top: 20px">
          <el-button size="small" @click="technologyDialog = false" style="margin-left: 20px">关闭</el-button>
          <el-button :disabled="selectStatus == 6" type="primary" size="small"
            @click="technologyDialogSave">保存</el-button>
        </div>
      </el-dialog>

      <!-- 编辑生产任务开始 -->
      <el-dialog title="编辑生产任务" @close="cancelEditTask" :visible.sync="editDialogVisible" :width="W ? '68%' : '70%'"
        :close-on-click-modal="false" center>
        <el-form :model="addForm" style="width: 100%" class="add_form" :rules="rule" ref="editProFrom">
          <h3 style="margin-left: 16px">基础信息</h3>
          <div class="line"></div>
          <el-row :gutter="20" style="margin-bottom: 10px">
            <el-col :span="8">
              <span class="title" style="margin-left: 42px">工单号：</span>
              <el-form-item class="value" prop="productionBatchCode">
                <el-input style="width: 160px" disabled v-model="addForm.productionBatchCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="position: relative">
              <span class="title" style="margin-left: 0px">生产任务单号：</span>
              <el-form-item class="value" prop="productionCodeParent">
                <el-input style="width: 160px" disabled v-model="addForm.productionCodeParent"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="position: relative">
              <span class="title texture" style="margin-left: 56px">行号：</span>
              <el-form-item class="value" prop="seqNo">
                <el-input style="width: 160px" disabled v-model="addForm.seqNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin-bottom: 10px">
            <el-col :span="8">
              <span class="title is-my-required" style="margin-left: 30px">物料编码：</span>
              <el-form-item class="value" prop="materialId">
                <el-select disabled @clear="remoteMethod" v-model="addForm.materialId" remote filterable
                  :loading="loading" @visible-change="(ev) => {
                    if (ev) {
                      this.remoteMethod('', '', '');
                    }
                  }
                    " :remote-method="(query) => {
                      this.remoteMethod('', query, '');
                    }
                      " @change="materialSelect" placeholder="请选择" style="width: 280px" clearable
                  :style="W ? { maxWidth: '280px' } : { maxWidth: '160px' }">
                  <el-option v-for="item in materialList" :key="item.id" :label="item.materialCode"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="position: relative">
              <span class="title is-my-required" style="margin-left: 30px">物料名称：</span>
              <el-form-item class="value" prop="materialId">
                <el-select disabled v-model="addForm.materialId" remote filterable :loading="loading" @visible-change="(ev) => {
                  if (ev) {
                    this.remoteMethod('', '', '');
                  }
                }
                  " :remote-method="(query) => {
                    this.remoteMethod(query);
                  }
                    " @change="materialSelect" placeholder="请选择" style="width: 280px" clearable
                  :style="W ? { maxWidth: '280px' } : { maxWidth: '160px' }">
                  <el-option v-for="item in materialList" :key="item.id" :label="item.materialName" :value="item.id">
                    <span>{{ item.materialName }}</span>
                    <span style="color: red">{{ item.specification }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="position: relative">
              <span class="title is-my-required" style="margin-left: 30px">规格型号：</span>
              <el-form-item class="value" prop="materialId">
                <el-select disabled @clear="remoteMethod" v-model="addForm.materialId" remote filterable
                  @visible-change="(ev) => {
                    if (ev) {
                      this.remoteMethod('', '', '');
                    }
                  }
                    " :loading="loading" :remote-method="(query) => {
                      this.remoteMethod('', '', query);
                    }
                      " @change="materialSelect" placeholder="请选择" style="width: 280px" clearable
                  :style="W ? { maxWidth: '280px' } : { maxWidth: '160px' }">
                  <el-option v-for="item in materialList" :key="item.id" :label="item.specification"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin-bottom: 10px">
            <el-col :span="8" style="position: relative">
              <span class="title" style="margin-left: 30px">客户名称：</span>
              <el-form-item class="value" prop="customerId">
                <el-select disabled v-model="addForm.customerId" remote placeholder="请选择" style="width: 280px" clearable
                  :style="W ? { maxWidth: '280px' } : { maxWidth: '160px' }">
                  <el-option v-for="item in customList" :key="item.id" :label="item.customerName"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <span class="title" style="margin-left: 42px">订单号：</span>
              <el-form-item class="value">
                <el-select disabled v-model="addForm.erpBusinessOrderCode" :allow-create="true" filterable
                  @change="businessOrderSelect" placeholder="请选择" style="width: 280px" clearable
                  :style="W ? { maxWidth: '280px' } : { maxWidth: '160px' }">
                  <el-option v-for="item in businessOrderList" :key="item.id" :label="item.orderCode"
                    :value="item.orderCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="position: relative">
              <span class="title is-my-required" style="margin-left: 30px">计划数量：</span>
              <el-form-item class="value" prop="splitCount">
                <el-input disabled :maxlength="16" v-model="addForm.splitCount" placeholder="计划数量" style="width: 280px"
                  :style="W ? { maxWidth: '280px' } : { maxWidth: '160px' }"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin-bottom: 10px">
            <el-col :span="8" style="position: relative">
              <span class="title texture" style="margin-left: 56px">件数：</span>
              <el-form-item class="value" prop="auxQty">
                <el-input style="width: 160px" disabled v-model="addForm.auxQty"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <span class="title">计划开始时间：</span>
              <el-form-item class="value" prop="planStartTime">
                <el-date-picker :picker-options="pickerOption" disabled v-model="addForm.planStartTime" type="date"
                  placeholder="选择日期" style="width: 280px"
                  :style="W ? { maxWidth: '280px' } : { maxWidth: '160px' }"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <span class="title">计划结束时间：</span>
              <el-form-item class="value" prop="planEndTime">
                <el-date-picker :picker-options="pickerOption1" disabled v-model="addForm.planEndTime" type="date"
                  placeholder="选择日期" style="width: 280px"
                  :style="W ? { maxWidth: '280px' } : { maxWidth: '160px' }"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8" style="position: relative">
              <span class="title is-my-required" style="margin-left: 30px">工单类型：</span>
              <el-form-item class="value" prop="productionType">
                <el-select disabled v-model="addForm.productionType" remote placeholder="请选择" style="width: 280px"
                  clearable :style="W ? { maxWidth: '280px' } : { maxWidth: '160px' }">
                  <el-option v-for="item in addOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8" style="position: relative; left: 30px">
              <span class="title">按序报工：</span>
              <el-form-item class="value" prop="postInOrder">
                <el-switch style="display: inline-block" disabled v-model="addForm.postInOrder" active-color="#13ce66"
                  inactive-color="#ccc"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="position: relative">
              <span class="title texture" style="margin-left: 30px">消耗时长：</span>
              <el-form-item class="value" prop="consumeDuration">
                <el-input style="width: 160px" v-model="addForm.consumeDuration"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8" style="position: relative">
              <span class="title texture" style="margin-left: 56px">时差：</span>
              <el-form-item class="value" prop="timeDifference">
                <el-input style="width: 160px" v-model="addForm.timeDifference"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20" style="margin-bottom: 10px">
            <el-col :span="24">
              <span class="title" style="
                  margin-left: 30px;
                  width: 70px;
                  display: inline-block;
                  text-align: right;
                ">备注：</span>
              <el-form-item class="value">
                <el-input type="textarea" show-word-limit :autosize="{ minRows: 2, maxRows: 3 }" :maxlength="300"
                  v-model="addForm.remark" placeholder="备注"
                  :style="W ? { width: '864px' } : { width: '700px' }"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin-bottom: 10px">
            <el-col :span="24">
              <span class="title" style="
                  margin-left: 30px;
                  width: 70px;
                  display: inline-block;
                  text-align: right;
                ">技术要求：</span>
              <el-form-item class="value">
                <el-input :autosize="{ minRows: 2, maxRows: 3 }" type="textarea" maxlength="255" :show-word-limit="true"
                  v-model="addForm.technicalSpecification" placeholder="技术要求"
                  :style="W ? { width: '864px' } : { width: '700px' }"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- <h3 style="margin-left:16px">扩展信息</h3>
          <div class="line"></div>
          <el-row :gutter="20" style="margin-bottom:10px">
            <el-col v-for="item in propertyExtendListCopy" :key="item.id" :span="8" style="position:relative">
              <span class="title custome-title">{{ item.propertyName }}：</span>
              <el-form-item class="value">
                <el-input
                  :disabled="item.isDeleted || !isEdit"
                  v-if="item.inputType == 0"
                  :maxlength="300"
                  v-model="item.propertyValue"
                  placeholder="请输入"
                  style="width:280px"
                  clearable
                  :style="W ? { maxWidth: '280px' } : { maxWidth: '160px' }"
                ></el-input>
                <el-select
                  :disabled="item.isDeleted || !isEdit"
                  filterable
                  v-if="item.inputType == 1"
                  v-model="item.propertyValue"
                  remote
                  placeholder="请选择"
                  style="width:280px"
                  clearable
                  :style="W ? { maxWidth: '280px' } : { maxWidth: '160px' }"
                >
                  <el-option v-for="value in item.values" :key="value" :label="value" :value="value"></el-option>
                </el-select> -->
          <!-- <el-tootip content="复制"> -->
          <!-- <i v-if="item.propertyValue != '' && item.propertyValue != null" class="el-icon-document-copy" style="cursor:pointer;" @click="copyPropertyValue(item.propertyValue)"></i> -->
          <!-- </el-tootip> -->
          <!-- </el-form-item>
            </el-col>
          </el-row> -->

          <h3 style="margin-left: 16px; margin-top: 16px">SOP信息</h3>
          <div class="line"></div>
          <el-form-item class="value file-item" style="margin-left: 20px">
            <div v-if="addForm.moduleImageIdList.length > 0" style="display: flex">
              <div v-for="(item, index) in addForm.moduleImageIdList" :key="index"
                style="width: 100px; height: 100px; margin-right: 18px">
                <div>
                  <div class="file-icon-container" :style="{ backgroundImage: `url(${item.filePath})` }"
                    @click="showFile(item.url)">
                    <div class="file-delete" @click.stop="deleteFile(index)"></div>
                  </div>
                  <el-tooltip class="item" effect="dark" :content="item.fileName" placement="bottom-end">
                    <span class="file-name">{{ item.fileName | parseName }}</span>
                  </el-tooltip>
                </div>
              </div>
            </div>
            <div v-if="addForm.moduleImageIdList.length < 5" style="
                width: 100px;
                height: 100px;
                border: dotted #409eff 1px;
                text-align: center;
              " @click="selectUploadFile(addForm.moduleImageIdList.length)">
              <i class="el-icon-plus" style="width: 100px; height: 100px; margin-top: 40px; font-size: 20px"></i>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button type="primary" @click="submitEditTask">确 定</el-button>
          <el-button @click="cancelEditTask">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 编辑生产任务结束 -->

      <!-- 生产排程 -->
      <SchedulingDialog :visible.sync="schedulingDialog" :workershopList="workershopList"
        :productionStateOption="ProductionStateOption" />
      <!-- 生产排程 -->
      <MaterialConfigDialog :visible.sync="materialConfigDialog" :workershopList="workershopList"
        :productionStateOption="ProductionStateOption" />

      <FileView ref="fileView" />
      <MaterialAlignment :splitData.sync="splitData" :isShow.sync="showAlignment"></MaterialAlignment>
    </template>

    <template v-if="showPage == 2">
      <ProductionProgressView :selectedSplit="selectedSplit" :propertyExtendList="propertyExtendList">
      </ProductionProgressView>
    </template>

    <template v-if="showPage == 3">
      <ProductionPlanEdit :selectedSplit="selectedSplit"></ProductionPlanEdit>
    </template>
    <OrderOperatorHistory :visible.sync="orderOperatorHistoryDialog" :order="currentRow"></OrderOperatorHistory>

    <!-- 班组交接班配置 -->
    <WorkshopShiftConfig :visible.sync="workshopShiftConfigDialog" />
    <!-- 班组交接班配置 -->
  </div>
</template>

<script>
import ProductionPlanEdit from "./ProductionPlanEdit.vue";
import MaterialAlignment from "./MaterialAlignment.vue";
import ProductionProgressView from "./ProductionProgressView.vue";
import CommonUtils from "@/util/CommonUtils";
import FileView from "@/components/common/FileView.vue";
import SchedulingDialog from "./SchedulingDialog";
import MaterialConfigDialog from "./MaterialConfigDialog";
import OrderOperatorHistory from "./OrderOperatorHistory.vue";
import WorkshopShiftConfig from "./WorkshopShiftConfig";


export default {
  name: "ProductionTask",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value !== "") {
        if (value > 0) {
          if (/^([-+]?\d{1,10})(\.\d{1,5})?$/.test(value) === false) {
            callback(new Error("数量最多可输入10整数和5位小数"));
          } else {
            callback();
          }
        } else {
          callback(new Error("数量必须大于零"));
        }
      } else {
        callback(new Error("请输入数量"));
      }
    };
    let that = this;
    return {
      workshopShiftConfigDialog: false,
      orderOperatorHistoryDialog: false,
      currentRow: {},
      selectRows: [],
      schedulingDialog: false,
      materialConfigDialog: false,

      ProductionStateOption: [],
      bomDialog: false,
      bomData: [],
      technologyDialog: false,
      technologyData: [],
      isEdit: false,
      showMore: false,
      splitData: {},
      showAlignment: false,
      orderType: "DESC", //排序类型
      orderColumn: null, //排序列
      defaultSort: { prop: null, order: "descending" }, //默认排序设置
      configDialogVisisble: false,
      showCancelSplitDialog: false,
      cancelSplitOrderList: [],
      selectCancelSplitOrderList: [],
      selectTableColumns: [
        "productionBatchCode",
        "erpBusinessOrderCode",
        "seqNo",
        "materialName",
        "materialCode",
        "materialQualityName",
        "specification",
        "splitCount",
        "auxQty",
        "splitRemark",
        "remark",
        "kittingStatus",
        "workshopName",
        "tecId",
        "deliverTime",
        "planStartTime",
        "planEndTime",
        "productionType",
        "gmtCreate",
        "gmtModified",
        "updateUserName",
        "splitStatus",
        "postInOrder",
        "parallelReport",
        "partProcessRatio",
        "action1",
        "customerName",
        "productionCodeParent",
        "productionState",
      ],
      tableColumnConfig: [
        {
          key: "productionBatchCode",
          value: "工单/子工单号",
          disabled: true,
          isShow: true,
          width: 185,
        },
        {
          key: "erpBusinessOrderCode",
          value: "订单号",
          disabled: false,
          isShow: true,
          width: 100,
        },
        { key: "seqNo", value: "订单行", disabled: false, isShow: true, width: 80 },
        {
          key: "materialName",
          value: "物料名称",
          disabled: false,
          isShow: true,
          width: 155,
        },
        {
          key: "materialCode",
          value: "物料编码",
          disabled: true,
          isShow: true,
          width: 155,
        },
        // { key: "materialQualityName", value: "材质", disabled: true, isShow: true, width: 100 },
        { key: "specification", value: "规格", disabled: false, isShow: true, width: 130 },
        {
          key: "splitCount",
          value: "计划数量",
          disabled: false,
          isShow: true,
          width: 90,
        },
        { key: "auxQty", value: "件数", disabled: false, isShow: true, width: 70 },
        {
          key: "splitRemark",
          value: "拆分说明",
          disabled: false,
          isShow: true,
          width: 70,
        },
        { key: "remark", value: "备注", disabled: false, isShow: true, width: 70 },
        {
          key: "kittingStatus",
          value: "齐套状态",
          disabled: false,
          isShow: false,
          width: 50,
        },
        { key: "workshopName", value: "机组", disabled: false, isShow: true, width: 120 },
        { key: "tecId", value: "工艺路线", disabled: true, isShow: true, width: 220 },
        {
          key: "deliverTime",
          value: "工单交付时间",
          disabled: false,
          isShow: true,
          width: 110,
        },
        {
          key: "planStartTime",
          value: "计划开始时间",
          disabled: false,
          isShow: true,
          width: 148,
        },
        {
          key: "planEndTime",
          value: "计划完工时间",
          disabled: false,
          isShow: true,
          width: 138,
        },
        {
          key: "productionType",
          value: "工单类型",
          disabled: false,
          isShow: true,
          width: 80,
        },
        { key: "gmtCreate", value: "创建时间", disabled: false, isShow: true, width: 96 },
        {
          key: "gmtModified",
          value: "更新时间",
          disabled: false,
          isShow: true,
          width: 100,
        },
        {
          key: "updateUserName",
          value: "最后操作人",
          disabled: false,
          isShow: true,
          width: 100,
        },
        {
          key: "splitStatus",
          value: "工单状态",
          disabled: false,
          isShow: true,
          width: 110,
        },
        {
          key: "postInOrder",
          value: "App按序报工",
          disabled: false,
          isShow: true,
          width: 140,
        },
        {
          key: "parallelReport",
          value: "批次报工",
          disabled: false,
          isShow: true,
          width: 140,
        },
        {
          key: "partProcessRatio",
          value: "工单进度",
          disabled: false,
          isShow: true,
          width: 74,
        },
        { key: "action1", value: "操作", disabled: true, isShow: true, width: 450 },
        {
          key: "customerName",
          value: "客户名称",
          disabled: true,
          isShow: true,
          width: 200,
        },
        {
          key: "productionCodeParent",
          value: "生产任务单号",
          disabled: true,
          isShow: true,
          width: 155,
        },
        {
          key: "productionState",
          value: "工单生产状态",
          disabled: true,
          isShow: true,
          width: 120,
        },
      ],
      propertyExtendListCopy: [],
      editDialogVisible: false,
      pickerOption: {
        disabledDate(time) {
          if (that.addForm.planEndTime) {
            return (
              time.getTime() > that.addForm.planEndTime ||
              time.getTime() < Date.now() - 24 * 60 * 60 * 1000
            );
          } else {
            return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
          }
        },
      },
      pickerOption1: {
        disabledDate(time) {
          if (that.addForm.planStartTime) {
            return time.getTime() < that.addForm.planStartTime;
          } else {
            return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
          }
        },
      },
      exportInfo: {
        success: 0,
        fail: 0,
        url: "",
        total: 0,
      },
      exportDialogVisible: false,
      W: false,
      addOptions: [
        { id: 0, label: "正常生产" },
        { id: 1, label: "加急生产" },
      ],
      materialList: [],
      addForm: {
        planEndTime: "",
        planStartTime: "",
        productionType: 0,
        splitCount: "",
        materialId: null,
        erpBusinessOrderCode: "",
        remark: "",
        orderCount: "",
        postInOrder: true,
        parallelReport: true,
        customerId: null,
        moduleImageIdList: [],
        splitDeliverTime: "",
        businessOrderSplitPropertyExtendList: [],
        hasTexture: false,
        customerDisable: false,
        productionBatchCode: "",
      },
      propertyExtendList: [],
      customList: [],
      addDialogVisible: false,
      showPrintDialog: false,
      printForm: {
        printModelData: [],
        templateType: 1,
      },
      printModelData: [],
      selectedSplit: {},
      showPage: 1,
      selectTaskId: null,
      selectRowData: {},
      splitForm: {
        splitOrderList: [],
      },
      rules: {
        everySalary: [
          {
            validator(rule, value, callback) {
              if (value) {
                let reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,4})?$/;
                if (!reg.test(value)) {
                  callback(`工价大于零且最多可保留4位小数`);
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        splitCount: [
          { required: false, message: "请输入每份数量", trigger: "blur" },
          {
            validator(rule, item, callback) {
              let value = item.splitCount;
              log(value, 888);
              if (value) {
                value = Number(value);
                if (isNaN(value)) {
                  callback(new Error("拆分数量必须为数字"));
                } else {
                  if (value > 0) {
                    let len = (String(value).split(".")[1] || "").length;
                    if (len > 2) {
                      callback(new Error("拆分数量最多可保留2位小数"));
                    } else {
                      callback();
                    }
                  } else {
                    callback(new Error("拆分数量必须大于零"));
                  }
                }
              } else {
                if (value === "0") {
                  callback(new Error("拆分数量必须大于零"));
                } else {
                  callback();
                }
              }
            },
            trigger: "blur",
          },
        ],
        orderCount: [
          { required: false, message: "请输入每份订单数量", trigger: "blur" },
          {
            validator(rule, item, callback) {
              let value = item.orderCount;
              if (value) {
                value = Number(value);
                if (isNaN(value)) {
                  callback(new Error("订单数量必须为数字"));
                } else {
                  if (value >= 0) {
                    let len = (String(value).split(".")[1] || "").length;
                    if (len > 2) {
                      callback(new Error("订单数量最多可保留2位小数"));
                    } else {
                      callback();
                    }
                  } else {
                    callback(new Error("订单数量不能小于零"));
                  }
                }
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        flowCardTemplateId: [
          { required: true, message: "请选择打印模版", trigger: "blur" },
        ],
        amount: [
          { required: true, message: "请输入打印份数", trigger: "blur" },
          {
            validator(rule, item, callback) {
              let value = item.amount;
              if (Number.isInteger(Number(value)) && Number(value) > 0) {
                callback();
              } else {
                callback(new Error("请输入正整数"));
              }
            },
            trigger: "blur",
          },
        ],
      },
      rule: {
        splitCount: [
          { required: true, validator: validatePass, trigger: ["blur", "change"] },
        ],
        productionType: [
          { required: true, message: "请选择工单类型", trigger: ["blur", "change"] },
        ],
        orderCount: [
          {
            validator(rule, value, callback) {
              if (value) {
                if (value > 0) {
                  if (/^([-+]?\d{1,10})(\.\d{1,5})?$/.test(value) === false) {
                    callback(new Error("数量最多可输入10整数和5位小数"));
                  } else {
                    callback();
                  }
                } else {
                  callback(new Error("数量必须大于零"));
                }
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
        materialId: [
          { required: true, message: "请选择物料", trigger: ["blur", "change"] },
        ],
        materialQualityName: [
          { required: false, message: "请选择材质", trigger: ["blur", "change"] },
        ],
        consumeDuration: [
          {
            validator(rule, value, callback) {
              if (value) {
                let reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1})?$/;
                if (!reg.test(value)) {
                  callback(`消耗时长大于零且最多可保留1位小数`);
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        timeDifference: [
          {
            validator(rule, value, callback) {
              if (value) {
                let reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1})?$/;
                if (!reg.test(value)) {
                  callback(`时差大于零且最多可保留1位小数`);
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      finishRangeRules: {
        finishRangeRote: [
          { required: false, message: "请输入完工范围百分比", trigger: "blur" },
          {
            validator(rule, item, callback) {
              let value = item;
              if (value) {
                value = Number(value);
                if (isNaN(value)) {
                  callback(new Error("完工范围百分比必须为数字"));
                } else {
                  if (Number.isInteger(Number(value)) && Number(value) >= 0) {
                    if (Number(value) > 100) {
                      callback(new Error("完工范围百分比不能大于100"));
                    } else {
                      callback();
                    }
                  } else {
                    callback(new Error("请输入正整数"));
                  }
                }
              } else {
                if (value === "0") {
                  callback();
                } else {
                  callback(new Error("完工范围百分比不能小于0"));
                }
              }
            },
            trigger: "blur",
          },
        ],
      },
      finishRangeForm: {
        finishRangeRote: 0,
      },
      showFinishRangeDialog: false,
      splitOrderList: [],
      showSplitDialog: false,
      loading: false,
      materialList: [],
      page: {
        total: 0,
        pageSize: 4,
        isShow: true,
      },
      viewType: 1,
      searchForm: {
        daterange: [],
        orderCode: "",
        productionBatchCode: "",
        materialName: "",
        materialCode: "",
        splitPlanType: "",
        factoryModelId: [],
        splitStatus: [0, 1, 3, 4],
        erpBusinessOrderCode: "",
        customerId: "",
        specification: "",
      },
      orderStatusOptions: [
        // 0-未排产 1-已排产 2-已下达 3-生产中 4-已完成 5-已关闭 6-工艺已分解 7-工序派工
        { id: 0, label: "未排产", value: 0 },
        // { id: 6, label: "工艺已分解", value: 6 },
        { id: 1, label: "已排产", value: 1 },
        // { id: 2, label: "已下达", value: 2 },
        // { id: 7, label: "工序派工", value: 7 },
        { id: 3, label: "生产中", value: 3 },
        { id: 4, label: "已完成", value: 4 },
        // { id: 5, label: "已关闭", value: 5 }
      ],
      textureList: [],
      workershopList: [],
      tableData: [],
      orderTypeOptions: [
        { label: "正常生产", value: 0, id: 0 },
        // {label:'返工生产',value:1,id:1},orderStatusOptions
        { label: "加急生产", value: 1, id: 1 },
        // { label: '外购', value: 2, id: 2 },
      ],
      printTemplateList: [], //打印模板
      taskList: [], //待发送任务列表
      frequency: 10, //发送修改数据的频率
      timer: null,
      permission: JSON.parse(localStorage.getItem("permission")),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 60 * 60 * 24 * 1000;
        },
      },
      searchStr: "",
      oldMaterialId: null,
      businessOrderList: [],
      businessOrderListCopy: [],
      splitItemList: [],
      selectStatus: 0,
    };
  },
  mounted: async function () {
    this.getDict("ProductionState");
    // let viewType = localStorage.getItem("viewType");
    // if (viewType) {
    //   this.viewType = viewType;
    // }
    if (this.viewType == 1) {
      this.page.pageSize = 10;
    }
    let { type, productionBatchCode } = this.$route.query;
    if (type && productionBatchCode) {
      let row = await this.loadProductionTaskByProductionBatchCode(productionBatchCode);
      this.showProductionPlanView(row);
      return;
    }
    let w = document.documentElement.clientWidth || document.body.clientWidth;
    w >= 1900 ? (this.W = true) : (this.W = false);
    window.onresize = () => {
      let w = document.documentElement.clientWidth || document.body.clientWidth;
      w >= 1900 ? (this.W = true) : (this.W = false);
    };
    if (window.devicePixelRatio != 1 && window.devicePixelRatio != 2) {
      this.$notify({
        title: "提示",
        message:
          "你的页面处于缩放状态，页面显示会有问题，请设置为正常状态。windows:ctrl+0   mac:command+0",
        type: "warning",
        duration: 9000,
      });
    }
    this.initConfig();
    // this.init()
    this.search();
    this.checkTask();
    this.loadWorkShopList();
    this.getCustomList();
    this.getPropertyExtendList();
    this.loadTextureList();
    this.businessOrderListCopy = await this.loadBusinessOrderList();
  },

  components: {
    ProductionPlanEdit,
    ProductionProgressView,
    MaterialAlignment,
    FileView,
    SchedulingDialog,
    MaterialConfigDialog,
    OrderOperatorHistory,
    WorkshopShiftConfig
  },
  computed: {
    span() {
      return this.W ? 6 : 6;
    },
    businessOrderListFilter() {
      if (this.addForm.customerId) {
        return this.businessOrderList.filter(
          (item) => item.customerId == this.addForm.customerId
        );
      } else {
        return this.businessOrderList;
      }
    },
  },
  beforeDestroy() {
    if (this.taskList.length > 0) {
      this.taskList.forEach((item) => {
        this.sendMessage(item.data);
      });
    }
    clearInterval(this.timer);
  },
  methods: {
    showWorkshopShiftConfig() {
      this.workshopShiftConfigDialog = true;
    },
    toQuality(row) {
      this.$router.push({
        name: "Quality",
        params: {
          productionBatchCode: row.id,
        },
      });
    },
    toQualityPrint(row) {
      this.$router.push({
        name: "QualityPrint",
        params: {
          materialId: row.materialId,
          materialCode: row.materialCode,
        },
      });
    },
    cancel(row) {
      this.$RequestUtil.post({
        url: "/api/productionTask/cancel",
        params: {
          id: row.id,
        },
        success: (res) => {
          if (res.code == 0) {
            this.$message.success("操作成功");
            this.search();
          } else {
            this.$message.error(res.message || res.msg);
          }
        },
      });
    },
    handleSelectionChange(val) {
      this.selectRows = val;
    },
    refreshList() {
      if (this.selectRows.length == 0) {
        this.$message.warning("请选择生产任务");
        return;
      }
      this.$RequestUtil.post({
        url: "/api/productionTask/update/base-info",
        params: {
          productionBatchCodeList: this.selectRows.map((row) => row.productionBatchCode),
        },
        success: (res) => {
          if (res.code == 0) {
            this.$message.success("操作成功");
            this.search();
          } else {
            this.$message.error(message || msg);
          }
        },
      });
    },
    parseDate(date) {
      let dateString = commonUtils.timestampToDate(date, true);
      return dateString;
    },
    showScheduling() {
      this.schedulingDialog = true;
    },
    showMaterialConfig() {
      this.materialConfigDialog = true;
    },
    getDict(dict) {
      this.$RequestUtil.get({
        url: "/api/pull/list/list-dic",
        type: "sync",
        params: {
          bizCode: dict,
        },
        success: (res) => {
          this[dict + "Option"] = res.data;
        },
      });
    },
    parseProductionState(row) {
      if (row.productionState) {
        const state = this.ProductionStateOption.find(
          (e) => e.key == row.productionState
        );
        return state.name;
      }
    },
    async showBom(row) {
      let { code, data, message, msg } = await this.$RequestUtil.getAsync({
        url: "/api/productionTask/technology-params",
        type: "sync",
        params: { id: row.id },
      });
      log(code, data, msg);
      if (code == 0) {
        this.bomData = data;
        this.bomDialog = true;
      } else {
        this.$message.error(message || msg);
      }
      // this.bomData = data[0]
    },
    async loadKittingStatus() {
      let splitIdList = this.tableData.map((item) => item.id);
      let { code, data, message, msg } = await this.$RequestUtil.getAsync({
        url: "/api/productionTask/getKittingStatus",
        type: "sync",
        params: { splitIdList: splitIdList.join(",") },
      });

      if (code == 0) {
        this.tableData.forEach((item, index) => {
          // item.kittingStatus = data[index].kittingStatus
          this.$set(item, "kittingStatus", data[index].kittingStatus);
        });
      } else {
        this.$message.error(message || msg);
      }
      // this.bomData = data[0]
    },

    parseProductionType(rowData) {
      if (rowData.productionType) {
        let find = [
          { id: 1, label: "自产" },
          { id: 2, label: "外协" },
          { id: 3, label: "自产+外协" },
          { id: 4, label: "外购" },
        ].find((item) => item.id == rowData.productionType);
        return find.label;
      }
    },
    copyPropertyValue(propertyValue) {
      const textArea = document.createElement("textArea");
      textArea.value = propertyValue;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      this.$message.success("复制成功");
    },
    visibleChange(ev) {
      if (!ev) {
        this.addForm.materialId = this.oldMaterialId;
      } else {
        this.remoteMethod("", "", "");
        this.oldMaterialId = this.addForm.materialId;
        this.addForm.materialId = this.searchStr;
      }
    },
    headerColWidthChange() {
      this.$refs.tableDataRef.doLayout();
      let thList = Array.from(
        this.$refs.tableDataRef.$el.querySelector(".has-gutter").querySelectorAll("th")
      );
      let arr = thList.map((item) => item.offsetWidth);
      this.selectTableColumns.forEach((item, index) => {
        let width = arr[index + 1];
        this.tableColumnConfig.forEach((t) => {
          if (t.key == item) {
            t.width = width;
          }
        });
      });

      // localStorage.setItem("tableColumnConfigInfo", JSON.stringify(this.tableColumnConfig));
    },

    computedColWidth(prop, defaultWidth) {
      let find = this.tableColumnConfig.find((item) => item.key == prop);
      if (find) {
        return find.width;
      } else {
        return defaultWidth;
      }
    },

    technologyIdView(row) {
      this.technologyDialog = true;
      this.$RequestUtil.get({
        url: "/api/productionTask/production-plan-every-salary",
        type: "sync",
        params: {
          businessOrderSplitId: row.id,
        },
        success: (res) => {
          if (res.code == 0) {
            this.selectStatus = row.splitStatus;
            this.technologyData = res.data;
          } else {
            this.$message.error(res.msg || res.message);
          }
        },
      });
    },
    technologyDialogSave() {
      let params = this.technologyData.map((val) => {
        let obj = {
          everySalary: 0,
          processPlanId: 0,
        };
        obj.processPlanId = val.processPlanId;
        obj.everySalary = val.everySalary != "" ? Number(val.everySalary) : 0;
        return obj;
      });
      if (params.length === 0) {
        this.$message.warning("无配置可保存!");
        return;
      }
      this.$RequestUtil.post({
        url: "/api/productionTask/production-plan-every-salary/update",
        type: "sync",
        params: params,
        success: (res) => {
          if (res.code == 0) {
            this.search(this.page.currentPage);
            this.showSplitDialog = false;
            this.$message.success("保存成功!");
          } else {
            this.$message.error(res.msg || res.message);
          }
        },
      });
      this.technologyDialog = false;
    },
    toggleShowMore() {
      this.showMore = !this.showMore;
    },
    deleteFile: function (index, type) {
      if (!this.permission.btn_file_upload) {
        this.$message({
          type: "error",
          message: `抱歉，您暂无文件删除权限`,
        });
        return false;
      }
      this.$confirm("此操作将删除该文件, 是否继续?", "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.addForm.moduleImageIdList.splice(index, 1);
      });
    },

    //传入文件名，返回文件对应路径
    getFilePath(fileName) {
      if (!fileName) {
        return;
      }
      let filePath = "";
      let arr = fileName.split(".");
      let suffix = arr[arr.length - 1];

      switch (true) {
        case suffix == "pdf" || suffix == "pptx":
          filePath = "/static/img/pdf.png";
          break;
        case suffix == "png" || suffix == "jpg" || suffix == "svg":
          filePath = "/static/img/pic.png";
          break;
        case suffix == "txt" || suffix == "doc" || suffix == "docx":
          filePath = "/static/img/txt.png";
          break;

        default:
          filePath = "/static/img/file.png";
      }

      return filePath;
    },

    selectUploadFile: function (index) {
      if (!this.permission.btn_fileSys_list) {
        this.$message.warning("您暂无文件管理权限");
        return;
      }
      this.$refs.fileView.initView(index, 1);
    },

    showFile: function (url) {
      if (!this.permission.btn_file_get) {
        this.$message({
          type: "error",
          message: `抱歉，您暂无文件读取权限`,
        });
        return false;
      }
      if (!url) {
        this.$message.warning("当前文件不存在");
        return;
      }
      let index = url.lastIndexOf(".");
      let ext = url.substr(index + 1).toLowerCase();
      //可直接被浏览器打开的文件类型
      let arr = [
        "pdf",
        "png",
        "jpg",
        "svg",
        "txt",
        "html",
        "js",
        "art",
        "au",
        "aiff",
        "xbf",
        "jpeg",
      ];
      if (arr.includes(ext)) {
        window.open(url, "_blank");
      } else {
        window.location.href = url;
      }
    },

    uploadComplete(response, index) {
      let fileInfo = {
        id: response.data.id,
        url: response.data.url,
        fileName: response.data.fileName,
        filePath: this.getFilePath(response.data.fileName),
      };
      this.$set(this.addForm.moduleImageIdList, index, fileInfo);
    },

    changeViewType(type) {
      this.viewType = type;
      if (type == 2) {
        this.page.pageSize = 4;
      } else {
        this.page.pageSize = 10;
      }
      this.search();
      // localStorage.setItem("viewType", type);
    },

    async loadTextureList() {
      let { data } = await this.$RequestUtil.getAsync({
        url: "/api/masterData/material-quality/list",
        params: {},
      });
      this.textureList = data;
    },

    async loadProductionTaskByProductionBatchCode(productionBatchCode) {
      let { data } = await this.$RequestUtil.postAsync({
        url: "/api/productionTask/list",
        params: { productionBatchCode, pageNum: 1, pageSize: 1 },
      });
      return data[0];
    },

    showEditPlan(rowData) {
      // <!-- 0-未排产 1-已排产 2-已下达 3-生产中 4-已完成 5-已关闭 6-工艺已分解 7-工序派工 -->
      // <!-- splitPlanType 0-任务编排 1-工单流转卡 2-工序派工 -->
      if (this.permission.btn_productionTask_updateList) {
        if (
          (rowData.splitStatus == 6 && rowData.splitPlanType === null) ||
          (rowData.splitPlanType === 0 &&
            (rowData.splitStatus == 1 ||
              rowData.splitStatus == 2 ||
              rowData.splitStatus == 3))
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    showPrintBtn(rowData) {
      if (this.permission.btn_productionPlan_printPlan) {
        if (rowData.splitPlanType == 1 || rowData.splitPlanType == 0) {
          return [2, 3, 4].includes(rowData.splitStatus);
        }
      }
      return false;
    },
    showStartProduction(rowData) {
      // if (this.permission.btn_plan_startProduction) {
      //   if ((rowData.splitPlanType === null && rowData.splitStatus == 6) || (rowData.splitPlanType === 0 && rowData.splitStatus == 1)) {
      //     return true;
      //   } else {
      //     return false;
      //   }
      // } else {
      //   return false;
      // }
      return true;
    },
    //排序改变事件
    sortChangeEvent(param) {
      let orderType = param.order;
      let orderColumn = param.prop;
      this.orderColumn = orderColumn;
      if (orderType == "descending") {
        this.orderType = "DESC";
      } else if (orderType == "ascending") {
        this.orderType = "ASC";
      } else {
        this.orderType = orderType;
        this.orderColumn = null;
      }
      this.page.currentPage = 1;
      this.search(1);
    },
    initConfig() {
      // let info = JSON.parse(localStorage.getItem("tableColumnConfigInfo"));
      // if (Array.isArray(info)) {
      //   if (info.findIndex(item => item.key == "remark") !== -1) {
      //     this.tableColumnConfig = info;
      //     this.selectTableColumns = this.tableColumnConfig.filter(item => item.isShow).map(item => item.key);
      //   }
      // } else {
      //   localStorage.setItem("tableColumnConfigInfo", JSON.stringify(this.tableColumnConfig));
      // }
      // this.$nextTick(() => {
      //   this.$refs.tableDataRef.doLayout();
      // });
    },

    getCustomList() {
      this.$RequestUtil.get({
        url: "/api/customer/list",
        type: "sync",
        params: {},
        success: (res) => {
          if (res.code == 0) {
            this.customList = res.data;
          } else {
            this.$message.error(res.msg || res.message);
          }
        },
      });
    },

    async getPropertyExtendList() {
      let { code, data } = await this.$RequestUtil.getAsync({
        url: "/api/property-extend/list",
        type: "sync",
        params: { type: 0 },
      });
      data.forEach((item) => {
        item.propertyValue = null;
      });
      this.propertyExtendList = data;
      // return data
    },
    async getSOPList(sourceId) {
      let { code, data } = await this.$RequestUtil.getAsync({
        url: "/api/moduleAttachment/listModuleAttachment",
        type: "sync",
        params: { sourceId },
      });
      return data;
    },
    async getCustomeValueList(businessOrderSplitId) {
      let { code, data } = await this.$RequestUtil.getAsync({
        url: "/api/businessOrderSplitPropertyExtend/listBusinessOrderSplitPropertyExtend",
        type: "sync",
        params: { businessOrderSplitId },
      });
      return data;
    },
    async materialSelect(id, type) {
      this.addForm.hasTexture = false;
      if (type) {
        this.searchStr = (
          this.materialList.find((item) => item.id == id) || {}
        ).materialCode;
      }
      if (id) {
        this.oldMaterialId = id;
      } else {
        this.oldMaterialId = null;
        this.searchStr = "";
        return;
      }
      let sopList = await this.getSOPList(id);
      sopList.forEach((item) => {
        item.filePath = this.getFilePath(item.fileName);
      });
      let selectItem = this.materialList.find((item) => item.id == id);

      if (selectItem) {
        this.$set(this.addForm, "postInOrder", selectItem.postInOrder);
        if (selectItem.materialQualityName) {
          this.$set(this.addForm, "materialQualityName", selectItem.materialQualityName);
          this.addForm.hasTexture = true;
        }
      }

      this.$set(this.addForm, "moduleImageIdList", sopList);
    },

    async loadBusinessOrderList(orderCode) {
      this.loading = true;
      let { code, data, message, msg } = await this.$RequestUtil.getAsync({
        url: "/api/select/getBusinessOrderList",
        type: "sync",
        params: { orderCode },
      });
      this.loading = false;
      if (code == 0) {
        this.businessOrderList = data;
        return data;
      } else {
        this.$message.error(message || msg);
      }
    },

    businessOrderSelect(ev, type) {
      let find = this.businessOrderList.findLast((item) => item.orderCode == ev) || {
        businessOrderItemList: [],
      };
      if (!type) {
        this.addForm.businessOrderItemId = null;
      }
      if (find.id) {
        this.splitItemList = find.businessOrderItemList;

        this.addForm.slectOrderInfo = find;
        this.addForm.orderId = find.id;
        this.addForm.customerId = find.customerId;
        this.addForm.customerDisable = true;
      } else {
        this.addForm.orderId = null;
        this.splitItemList = [];
        this.addForm.customerDisable = false;
        this.addForm.slectOrderInfo = { businessOrderItemList: [] };
      }
    },

    businessOrderItemSelect(ev, addForm) {
      this.$set(this.addForm, "businessOrderItemId", ev);
      let selectItem = this.splitItemList.find((item) => item.id == ev) || {};
      if (addForm && addForm.itemIndex && this.splitItemList.length == 0) {
        this.splitItemList.push({
          id: ev,
          itemIndex: addForm.itemIndex,
          materialCode: addForm.itemMaterialCode || "",
          materialName: addForm.itemMaterialName || "",
          specification: addForm.itemSpecification || "",
        });
      }
      this.addForm.selectItem = selectItem;
      this.addForm.orderCount = selectItem.itemCount;
      this.addForm.technicalSpecification = this.addForm.slectOrderInfo.technicalSpecification;
      this.addForm.splitDeliverTime =
        selectItem.itemDeliverTime || this.addForm.slectOrderInfo.deliverTime;
    },

    updateConfig() {
      this.configDialogVisisble = false;
      this.tableColumnConfig.forEach((item) => {
        if (this.selectTableColumns.includes(item.key)) {
          item.isShow = true;
        } else {
          item.isShow = false;
        }
      });
      let info = JSON.parse(localStorage.getItem("tableColumnConfigInfo"));

      localStorage.setItem("tableColumnConfigInfo", JSON.stringify(info));
      this.$nextTick(() => {
        this.$refs.tableDataRef.doLayout();
      });
    },
    cancelConfig() {
      this.selectTableColumns = this.tableColumnConfig
        .filter((item) => item.isShow)
        .map((item) => item.key);
      this.configDialogVisisble = false;
    },

    // 导入
    beforeLoad(file) {
      let fileSize = file.size / 1024 / 1024;
      fileSize = Math.round(fileSize * 100) / 100;
      if (fileSize >= 5) {
        this.$message({
          type: "error",
          message: `文件大小不能超过10M,当前上传${file.name}大小为${fileSize}M`,
        });
        return false;
      }
      this.$RequestUtil.loading();
    },

    remoteMethod: async function (materialName, materialCode, specification, type) {
      this.loading = true;
      if (type) {
        this.searchStr = materialCode;
      }
      await this.loadMaterialList(materialName, materialCode, specification);
      this.loading = false;
    },

    cancelFinishRangeDialog() {
      this.$refs["finishRangeForm"].clearValidate();
      this.showFinishRangeDialog = false;
    },

    submitFinishRangeDialog() {
      this.$refs["finishRangeForm"].validate((valid) => {
        if (valid) {
          this.$confirm(`调整完成后，会按照最新的完工范围执行,是否确认修改?`, "提示", {
            cancelButtonClass: "btn-custom-cancel",
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.$RequestUtil.post({
              url: "/api/ProductionElasticScaleConfig/setConfig",
              type: "sync",
              params: {
                scale: this.finishRangeForm.finishRangeRote,
              },
              success: (res) => {
                if (res.code == 0) {
                  this.$message.success("保存成功");
                  this.cancelFinishRangeDialog();
                } else {
                  this.$message.error(res.msg || res.message);
                }
              },
            });
          });
        } else {
          this.$message.warning("请输入正确信息！");
        }
      });
    },

    // 获取物料名称下拉选项
    async loadMaterialList(materialName, materialCode, specification) {
      let res = await this.$RequestUtil.getAsync({
        url: "/api/select/listMaterial",
        params: {
          materialName,
          materialCode,
          specification,
          isTechnology: true,
        },
      });
      if (res.code != 0) {
        this.$message.error(res.msg || res.message);
        return;
      }
      this.materialList = res.data;
    },

    async showEditTask(rowData) {
      if (rowData.splitStatus == 0 || rowData.splitStatus == 6) {
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
      this.addForm = CommonUtils.cloneObj(rowData);
      this.addForm.customerId = Number(this.addForm.customerId) || null;
      if (rowData.childProductionBatchCode) {
        this.addForm.isDisabled = true;
      } else {
        this.addForm.isDisabled = false;
      }
      this.loadMaterialList();
      if (!this.addForm.moduleImageURLList) {
        this.addForm.moduleImageURLList = [];
      }
      this.addForm.moduleImageURLList.forEach((item) => {
        item.filePath = this.getFilePath(item.fileName);
      });
      this.addForm.moduleImageIdList = this.addForm.moduleImageURLList;
      let find = this.materialList.find((item) => item.id == rowData.materialId);
      // this.addForm.hasTexture = false
      if (this.addForm.businessOrderId) {
        this.businessOrderSelect(this.addForm.erpBusinessOrderCode, true);
        if (this.addForm.businessOrderItemId) {
          this.businessOrderItemSelect(this.addForm.businessOrderItemId, this.addForm);
        }
      }
      if (!find) {
        let json = {
          materialCode: rowData.materialCode,
          materialName: rowData.materialName,
          specification: rowData.specification,
          id: rowData.materialId,
          materialId: rowData.materialId,
        };
        this.materialList.unshift(json);
      } else {
        //    if(find.materialQualityName){
        //     this.addForm.hasTexture = true
        //    }
      }
      // let res = await this.getCustomeValueList(rowData.id);

      // this.propertyExtendListCopy = commonUtils.cloneObj(this.propertyExtendList);
      // this.propertyExtendListCopy.forEach(item => {
      //   let index = res.findIndex(f => f.propertyExtendId == item.id);
      //   if (index > -1) {
      //     item.propertyValue = res[index].propertyValue;
      //     item.isDeleted = res[index].isDeleted;
      //     item.oldId = res[index].id;
      //     res.splice(index, 1);
      //   }
      // });
      // if (res.length > 0) {
      //   res.forEach(item => {
      //     this.propertyExtendListCopy.push({
      //       id: item.propertyExtendId,
      //       propertyName: item.propertyName,
      //       propertyValue: item.propertyValue,
      //       oldId: item.id,
      //       inputType: 0,
      //       values: [],
      //       isDeleted: item.isDeleted
      //     });
      //   });
      // }
      this.editDialogVisible = true;
    },
    unAddTask() {
      this.addDialogVisible = false;
      this.addForm = {
        planEndTime: "",
        planStartTime: "",
        productionType: "",
        splitCount: "",
        materialId: null,
        erpBusinessOrderCode: "",
        remark: "",
        orderCount: "",
        postInOrder: true,
        parallelReport: true,
        customerId: null,
        moduleImageIdList: [],
        materialQualityName: "",
        splitDeliverTime: "",
        businessOrderSplitPropertyExtendList: [],
        customerDisable: false,
      };
      this.propertyExtendList.forEach((item, index) => {
        item.propertyValue = null;
      });
      this.$refs.addProFrom.clearValidate();
    },

    // 新增任务单确定
    addTask() {
      this.$refs["addProFrom"].validate((valid) => {
        if (valid) {
          let businessOrderSplitPropertyExtendList = [];
          this.propertyExtendList.forEach((item) => {
            businessOrderSplitPropertyExtendList.push({
              propertyExtendId: item.id,
              propertyName: item.propertyName,
              propertyValue: item.propertyValue,
            });
            item.propertyValue = null;
          });
          if (this.addForm.orderId && !this.addForm.businessOrderItemId) {
            this.$message.error("关联主计划订单号订单行不能为空");
            return;
          }
          let params = {
            productionType: this.addForm.productionType,
            materialId: this.addForm.materialId,
            splitCount: this.addForm.splitCount,
            planStartTime: this.addForm.planStartTime,
            planEndTime: this.addForm.planEndTime,
            erpBusinessOrderCode: this.addForm.erpBusinessOrderCode,
            remark: this.addForm.remark,
            orderCount: this.addForm.orderCount,
            businessOrderSplitPropertyExtendList,
            moduleImageIdList: this.addForm.moduleImageIdList.map((item) => item.id),
            parallelReport: this.addForm.parallelReport,
            postInOrder: this.addForm.postInOrder,
            splitDeliverTime: this.addForm.splitDeliverTime,
            customerId: this.addForm.customerId,
            materialQualityName: this.addForm.materialQualityName,
            technicalSpecification: this.addForm.technicalSpecification,
            productionBatchCode: this.addForm.productionBatchCode,
          };

          if (this.addForm.orderId) {
            // 关联主计划订单号
            params.businessOrderItemId = this.addForm.businessOrderItemId;

            params.businessOrderId = this.addForm.orderId;
            // params.orderCount = this.addForm.selectItem.itemOrderCount
            // params.technicalSpecification = this.addForm.slectOrderInfo.technicalSpecification
            // params.splitDeliverTime = this.addForm.selectItem.itemDeliverTime||this.addForm.slectOrderInfo.deliverTime
          }

          this.$RequestUtil.post({
            url: "/api/productionTask/addSplit",
            type: "sync",
            params,
            success: (res) => {
              if (res.code == 0) {
                this.$message.success("修改成功");
                this.unAddTask();
                this.search();
              } else {
                this.$message.error(res.msg || res.message);
              }
            },
          });
        } else {
          this.$message.warning("请输入正确信息！");
        }
      });
    },

    submitEditTask() {
      if (true) {
        this.$refs["editProFrom"].validate((valid) => {
          if (valid) {
            let businessOrderSplitPropertyExtendList = [];
            this.propertyExtendListCopy.forEach((item) => {
              businessOrderSplitPropertyExtendList.push({
                propertyExtendId: item.id,
                propertyName: item.propertyName,
                propertyValue: item.propertyValue,
                id: item.oldId,
                isDeleted: item.isDeleted,
              });
              item.propertyValue = null;
            });
            if (this.addForm.orderId && !this.addForm.businessOrderItemId) {
              this.$message.error("关联主计划订单号订单行不能为空");
              return;
            }
            let params = {
              id: this.addForm.id,
              productionType: this.addForm.productionType,
              materialId: this.addForm.materialId,
              // splitCount: this.addForm.splitCount,
              // planStartTime: this.addForm.planStartTime,
              // planEndTime: this.addForm.planEndTime,
              // erpBusinessOrderCode: this.addForm.erpBusinessOrderCode,
              remark: this.addForm.remark,
              // orderCount: this.addForm.orderCount,
              // businessOrderSplitPropertyExtendList,
              moduleImageIdList: this.addForm.moduleImageIdList.map((item) => item.id),
              // parallelReport: this.addForm.parallelReport,
              // splitDeliverTime: this.addForm.splitDeliverTime,
              // postInOrder: this.addForm.postInOrder,
              // customerId: this.addForm.customerId,
              // materialQualityName: this.addForm.materialQualityName,
              technicalSpecification: this.addForm.technicalSpecification,
              timeDifference: this.addForm.timeDifference,
              consumeDuration: this.addForm.consumeDuration,
            };
            // if (this.addForm.orderId) {
            //   // 关联主计划订单号
            //   params.businessOrderItemId = this.addForm.businessOrderItemId;

            //   params.businessOrderId = this.addForm.orderId;
            //   // params.orderCount = this.addForm.selectItem.itemOrderCount
            //   // params.technicalSpecification = this.addForm.slectOrderInfo.technicalSpecification
            //   // params.splitDeliverTime = this.addForm.selectItem.itemDeliverTime||this.addForm.slectOrderInfo.deliverTime
            // }
            this.$RequestUtil.post({
              url: "/api/productionTask/update",
              type: "sync",
              params,
              success: (res) => {
                if (res.code == 0) {
                  this.$message.success("添加成功");
                  this.cancelEditTask();
                  this.search(this.page.currentPage);
                } else {
                  this.$message.error(res.msg || res.message);
                }
              },
            });
          } else {
            this.$message.warning("请输入正确信息！");
          }
        });
      } else {
        this.$RequestUtil.post({
          url: "/api/moduleAttachment/updateBySourceId",
          type: "sync",
          params: {
            sourceId: this.addForm.id,
            moduleImageIdList: this.addForm.moduleImageIdList.map((item) => item.id),
          },
          success: (res) => {
            if (res.code == 0) {
              this.$message.success("修改成功");
              this.cancelEditTask();
              this.search();
            } else {
              this.$message.error(res.msg || res.message);
            }
          },
        });
      }
    },

    cancelEditTask() {
      this.editDialogVisible = false;
      this.addForm = {
        planEndTime: "",
        planStartTime: "",
        productionType: "",
        splitCount: "",
        materialId: null,
        erpBusinessOrderCode: "",
        remark: "",
        orderCount: "",
        postInOrder: true,
        parallelReport: true,
        splitDeliverTime: "",
        customerId: null,
        moduleImageIdList: [],
        materialQualityName: "",
        businessOrderSplitPropertyExtendList: [],
        technicalSpecification: "",
        customerDisable: false,
      };
      this.propertyExtendList.forEach((item, index) => {
        item.propertyValue = null;
      });
      this.$refs.editProFrom.clearValidate();
      this.$refs.editProFrom.resetFields();
    },

    parseBatchCode(rowDate) {
      if (rowDate.childProductionBatchCode) {
        return rowDate.childProductionBatchCode;
      } else {
        return rowDate.productionBatchCode;
      }
    },
    parseOrderCode(row) {
      if (row.productionOrderCode) {
        return row.productionOrderCode;
      } else {
        return row.orderCode;
      }
    },

    async loadPrintTemplateList(workshopId, flowCardTemplateId, materialType) {
      let { data, code, msg, message } = await this.$RequestUtil.postAsync({
        url: "/api/select/listFlowCardTemplate ",
        type: "sync",
        params: { workshopId, materialType },
      });
      if (code == 0) {
        return data;
      } else {
        this.$message.error(msg || message);
        return false;
      }
    },
    printTemlateSelect(ev) {
      this.printForm.configInfo =
        this.printTemplateList.find((item) => item.flowCardTemplateId == ev) || {};
      this.printForm.templateType = (
        this.printTemplateList.find((item) => item.flowCardTemplateId == ev) || {}
      ).templateType;
    },
    async submitPrintDialog() {
      this.$refs["printForm"].validate(async (valid) => {
        if (valid) {
          let arr = this.printModelData.map((item) => {
            return {
              splitId: item.splitId,
              amount: item.amount,
              amountPer: item.amountPer,
            };
          });
          let params = {
            templateType: this.printForm.templateType,
            orderId: this.printForm.orderId,
            splitList: arr,
            printHistory: this.printForm.disabled,
            historyId: this.printForm.historyId,
            flowCardTemplateId: this.printForm.flowCardTemplateId,
            splitId: arr[0].splitId,
          };
          let { data, code, msg, message } = await this.$RequestUtil.postAsync({
            url: "/api/productionPlan/printPlan",
            type: "sync",
            params,
          });
          if (code == 0) {
            if (this.printForm.templateType == 1 || this.printForm.templateType == 3) {
              data.forEach((item) => {
                item.orderCode = this.printForm.orderCode;
                item.productionOrderCode = this.printForm.productionOrderCode;
                item.erpBusinessOrderCode = this.printForm.erpBusinessOrderCode;
              });
            }
            if (this.printForm.templateType == 4) {
              if (this.printForm.configInfo) {
                let configList = this.printForm.configInfo.flowCardTemplatePropertyDtos;
                if (configList.length > 0) {
                  let arr = [];
                  data.forEach((d) => {
                    configList.forEach((item) => {
                      if (item.propertyType == 1) {
                        item.text = d[item.fieldCode];
                      }

                      if (item.propertyType == 2) {
                        item.text = d.codeValue;
                      }
                    });
                    arr.push(configList);
                  });
                  this.printForm.configInfo.list = arr;
                }
              }
              localStorage.setItem(
                "printAllOrderData",
                JSON.stringify(this.printForm.configInfo)
              );
            } else {
              localStorage.setItem("printAllOrderData", JSON.stringify(data));
            }
            localStorage.setItem("modelType", this.printForm.templateType - 1);
            // localStorage.setItem('flowCardTemplateId', this.printForm.flowCardTemplateId)

            this.$refs["printForm"].clearValidate();
            this.showPrintDialog = false;
            this.search(this.page.currentPage);
            let routeUrl = this.$router.resolve({ path: "/printAllOrder" });
            window.open(routeUrl.href, "_blank");
          } else {
            this.$message.error(msg || message);
            return false;
          }
        }
      });
    },
    cancelPrintDialog() {
      this.showPrintDialog = false;
      this.printModelData = [];
      this.printForm = {
        printModelData: [],
        templateType: 1,
        flowCardTemplateId: null,
      };
    },
    pickerStartOption(row) {
      if (row.planEndTime) {
        return {
          disabledDate(time) {
            return (
              time.getTime() < Date.now() - 24 * 60 * 60 * 1000 ||
              time.getTime() > row.planEndTime
            );
          },
        };
      } else {
        return {
          disabledDate(time) {
            return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
          },
        };
      }
    },

    pickerEndOption(row) {
      if (row.planStartTime) {
        return {
          disabledDate(time) {
            return time.getTime() < row.planStartTime;
          },
        };
      } else {
        return {
          disabledDate(time) {
            return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
          },
        };
      }
    },

    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (column.property == "partProcessRatio") {
        return {
          cursor: "pointer",
        };
      }
    },
    parseProcess(rowDate) {
      if (rowDate.partProcessRatio != null) {
        return rowDate.partProcessRatio + "%";
      }
    },

    reload(page) {
      this.search(page);
      this.$store.commit("delete_reloadPages", "/ProductionTask");
      this.$forceUpdate();
    },
    async editOrder(ev, rowDate, type) {
      if (type == "date") {
        if (rowDate.planTime && rowDate.planTime.length == 2) {
          rowDate.planStartTime = new Date(rowDate.planTime[0]).getTime();
          rowDate.planEndTime = new Date(rowDate.planTime[1]).getTime();
        } else {
          rowDate.planStartTime = null;
          rowDate.planEndTime = null;
        }
      }
      if (type == "postInOrder") {
        if (ev == false && rowDate.parallelReport == true) {
          rowDate.parallelReport = false;
        }
      }
      let res = await this.$RequestUtil.postAsync({
        url: "/api/productionTask/updateList",
        params: { ...rowDate },
      });
      this.getMessage(res);
    },

    getMessage(res) {
      if (res && res.code == 0) {
        this.tableData.forEach((item) => {
          if (item.id == res.data.id) {
            this.$set(item, "gmtModified", res.data.gmtModified);
            this.$set(item, "splitStatus", res.data.splitStatus);
            this.$set(item, "technologyState", res.data.technologyState);
          }
        });
      } else {
        this.$message.error(res.msg || res.message);
      }
    },

    showProductionPlanEdit(row) {
      let find = row.tecList.find((item) => item.id == row.technologyId) || {};
      if (find.hasProcedure && find.hasProcedure == -1) {
        this.$message.error("工艺路线未审核,请重新选择!");
        return;
      }
      this.selectedSplit = row;
      this.selectedSplit.tecId = row.technologyId;
      this.selectedSplit.splitItemId = row.id;
      this.showPage = 3;
      this.selectedSplit.page = this.page.currentPage;
    },
    showDisPatchPaln(row) {
      this.$message.success("任务已下达，请前往派工单模块进行任务编排");
    },
    alignmentStatusDetails(row) {
      this.splitData = CommonUtils.cloneObj(row);

      this.showAlignment = true;
    },
    processDetails(row) {
      this.showProductionPlanView(row);
    },
    cellClick(row, column, cell, event) {
      if (column.property == "kittingStatus") {
        this.splitData = CommonUtils.cloneObj(row);

        this.showAlignment = true;
      }
      if (
        column.property == "partProcessRatio" &&
        this.permission.btn_plan_listPartProcessByPartPlan
      ) {
        this.showProductionPlanView(row);
      }
    },
    showProductionPlanView(row) {
      this.selectedSplit = row;
      this.selectedSplit.splitItemId = row.id;
      this.selectedSplit.page = this.page.currentPage;
      this.showPage = 2;
    },

    //根据订单状态判断工单是否可以编辑
    itemCanEdit1(rowDate) {
      if (rowDate.splitStatus == 4 || rowDate.splitStatus == 5) {
        return true;
      } else {
        return false;
      }
    },
    itemCanEdit(rowDate) {
      if (rowDate.splitStatus != 0 && rowDate.splitStatus != 6) {
        return true;
      } else {
        return false;
      }
    },

    //列表查询
    search(pageNum) {
      if (pageNum == null || pageNum instanceof KeyboardEvent) {
        pageNum = 1;
      }
      let form = this.searchForm;

      // let [planStartTimeStr, planEndTimeStr] = form.daterange;
      let planStartTimeStr, planEndTimeStr;
      if (form.daterange) {
        planStartTimeStr = form.daterange[0];
        planEndTimeStr = form.daterange[1];
      }

      let params = {
        pageNum,
        pageSize: this.page.pageSize,
        planStartTimeStr,
        planEndTimeStr,
        orderCode: form.orderCode,
        productionBatchCode: form.productionBatchCode,
        materialName: form.materialName,
        materialCode: form.materialCode,
        productionType: form.splitPlanType,
        factoryModelId: form.factoryModelId,
        splitStatus: form.splitStatus,
        orderType: this.orderType, //排序类型
        orderColumn: this.orderColumn,
        erpBusinessOrderCode: form.erpBusinessOrderCode,
        customerId: form.customerId,
        specification: form.specification,
      };
      this.selectRowData = {};
      this.selectTaskId = null;
      this.$RequestUtil.post({
        url: "/api/productionTask/list",
        type: "sync",
        params: params,
        success: (res) => {
          if (res.code != 0) {
            this.$message.error(res.message);
            return;
          }
          res.data.forEach((r) => {
            r.planStartTime = r.planStartTime ? r.planStartTime : "";
            r.planEndTime = r.planEndTime ? r.planEndTime : "";
            if (r.planStartTime) {
              r.planTime = [
                CommonUtils.timestampToDate(r.planStartTime),
                CommonUtils.timestampToDate(r.planEndTime),
              ];
            }
            (r.tecList || []).forEach((item) => {
              if (item.hasProcedure == -1) {
                item.routeName = item.routeName + "(工艺待审核)";
              } else if (item.hasProcedure == 0) {
                item.routeName = item.routeName + "(暂无工艺)";
              }
            });
          });
          this.tableData = res.data;
          this.page.currentPage = pageNum;
          this.page.total = res.totalPages;
          if (this.page.total == 0 && this.fristLoad) {
            this.$message.warning("查询不到符合条件的数据");
          }
          if (
            this.tableData.length > 0 &&
            this.permission.btn_productionTask_getKitting
          ) {
            this.loadKittingStatus();
          }

          this.fristLoad = true;
        },
      });
    },

    checkTask() {
      //定时检查发送到期任务
      this.timer = setInterval(() => {
        let now = new Date().getTime();
        this.taskList = this.taskList.filter((item) => {
          if (item.lastModifiedTime + this.frequency < now) {
            //找到到期任务推送给后端并删除任务
            this.sendMessage(item.data);
            return false;
          } else {
            return true;
          }
        });
      }, this.frequency * 1000);
    },

    taskSelect(ev, row) {
      this.selectRowData = row;
    },

    clickSearch() {
      this.search();
    },

    clearSearch() {
      this.searchForm = {
        daterange: [],
        orderCode: "",
        productionBatchCode: "",
        materialName: "",
        materialCode: "",
        splitPlanType: "",
        factoryModelId: [],
        splitStatus: [0, 1, 3, 4],
        erpBusinessOrderCode: "",
        customerId: "",
      };
    },

    pageChange(pageNum) {
      // this.$set(this, 'searchForm', commonUtils.cloneObj(this.searchCopy));
      this.search(pageNum);
    },

    parseType(rowDate) {
      if (rowDate.productionType != null && rowDate.productionType != undefined) {
        return (
          this.orderTypeOptions.find((item) => item.value == rowDate.productionType) || {}
        ).label;
      }
    },
    parseMaterialType(row) {
      let ev = row.itemType;
      if (ev != null) {
        if (ev == 0) {
          return "产品";
        } else if (ev == 1) {
          return "零件";
        } else if (ev == 2) {
          return "原材料";
        }
      }
    },

    parseStatus(rowDate) {
      let json = {
        text: "",
        textStye: {},
        radiusStyle: {},
      };
      switch (
      rowDate.splitStatus //0-未排产 1-已排产 2-已下达 3-生产中 4-已完成 5-已关闭 6-工艺已分解 7-工序派工
      ) {
        case 0:
          json.text = "未排产";
          json.textStye = {
            color: "#24d0f2",
          };
          json.radiusStyle = {
            background: "#f2331a",
          };
          break;
        case 1:
          json.text = "已排产";
          json.textStye = {};
          json.radiusStyle = {
            background: "#FAC916",
          };
          break;
        case 2:
          json.text = "已下达";
          json.textStye = {};
          json.radiusStyle = {
            background: "#24d0f2",
          };
          break;
        case 3:
          json.text = "生产中";
          json.textStye = {};
          json.radiusStyle = {
            background: "#71e2a3",
          };
          break;
        case 4:
          json.text = "已完成";
          json.textStye = {};
          json.radiusStyle = {
            background: "#409eff",
          };
          break;
        case 5:
          json.text = "已关闭";
          json.textStye = {
            color: "#02A7F0",
          };
          json.radiusStyle = {
            background: "#dddddd",
          };
          break;
        case 6:
          json.text = "工艺已分解";
          json.textStye = {
            color: "#00FF33",
          };
          json.radiusStyle = {
            background: "#dddddd",
          };
          break;
        case 7:
          json.text = "工序派工";
          json.textStye = {
            color: "#02A7F0",
          };
          json.radiusStyle = {
            background: "#dddddd",
          };
          break;
      }
      return json;
    },

    deleteSplitItem(index) {
      this.splitOrderList.splice(index, 1);
    },

    submitSplitOrder() {
      this.$refs["splitForm"].validate((valid) => {
        if (valid) {
          let index = 0;
          let countArr = [];
          let sum = 0;
          let last = 0;

          this.splitOrderList.forEach((item) => {
            if (!item.splitCount) {
              index++;
            } else {
              countArr.push({
                splitCount: Number(item.splitCount),
                orderCount: Number(item.orderCount),
                splitRemark: item.splitRemark,
              });
              sum += Number(item.splitCount);
            }
          });

          if (index > 1) {
            this.$message.warning("拆分数量最多只允许一组为空");
            return;
          }
          last = Math.round((this.splitForm.splitCount - sum) * 100) / 100;
          if (last < 0) {
            this.$message.warning(
              `拆分总量(${sum})不能大于生产数量(${this.splitForm.splitCount})，请重新填写`
            );
            return;
          } else if (last >= 0) {
            if (last != 0) {
              countArr.push({ splitCount: last, orderCount: 0, splitRemark: "" });
            }

            if (countArr.length == 1) {
              this.$message.warning("拆分份数必须大于1,请修改拆分数量");
              return;
            }
            let len = countArr.length;
            let str = countArr.map((item) => `{生产数量:${item.splitCount}}`).join(" | ");
            this.$confirm(
              `生产数量将会拆分为:${str}; ${len}份生产数量是否确认拆分?`,
              "提示",
              {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            ).then(() => {
              this.$RequestUtil.post({
                url: "/api/productionTask/doSplit",
                type: "sync",
                params: {
                  id: this.splitForm.id,
                  splitList: countArr,
                },
                success: (res) => {
                  if (res.code == 0) {
                    this.search(this.page.currentPage);
                    this.showSplitDialog = false;
                  } else {
                    this.$message.error(res.msg || res.message);
                  }
                },
              });
            });
          }
        }
      });
    },

    selecttableColumn(row) {
      if (row.isLock) {
        return false;
      }
      return true;
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isLock) {
        return "select-row";
      }
      return "";
    },
    submitCancelSplitOrder() {
      // 无法提交，请最少选择一个工单后再提交
      // this.$refs.cancelSplitTable.
      if (this.selectCancelSplitOrderList.length == 1) {
        this.$message.warning("无法提交，请最少选择一个工单后再提交");
        return;
      }
      let orderStr = this.selectCancelSplitOrderList
        .filter((f) => !f.isLock)
        .map((m) => m.productionBatchCode)
        .join("、");
      let order1 = this.selectCancelSplitOrderList
        .filter((f) => f.isLock)
        .map((m) => m.productionBatchCode)[0];
      this.$confirm(`此操作将把工单${orderStr}合并到${order1},是否确认合并?`, "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.search(this.page.currentPage);
        this.showCancelSplitDialog = false;

        this.$RequestUtil.post({
          url: "/api/productionTask/cancelSplit",
          type: "sync",
          params: {
            id: this.selectCancelSplitOrderList
              .filter((f) => f.isLock)
              .map((m) => m.id)[0],
            mergeIdList: this.selectCancelSplitOrderList
              .filter((f) => !f.isLock)
              .map((m) => m.id),
          },
          success: (res) => {
            if (res.code == 0) {
              this.search(this.page.currentPage);
              this.$message.success("工单取消拆分成功");
            } else {
              this.$message.error(res.msg || res.message);
            }
          },
        });
      });
    },
    handleSelectCancelSplitOrder(ev) {
      this.selectCancelSplitOrderList = [];
      ev.forEach((f) => {
        this.selectCancelSplitOrderList.push({
          productionBatchCode: f.productionBatchCode,
          isLock: f.isLock,
          id: f.id,
        });
      });
    },
    async loadcancelOrder() {
      let { data, code, msg, message } = await this.$RequestUtil.getAsync({
        url: "/api/productionTask/getRemoveSplitList",
        type: "sync",
        params: { id: this.selectRowData.id },
      });
      if (code == 0) {
        return data;
      } else {
        this.$message.error(msg || message);
      }
    },

    addSplitItem() {
      this.splitOrderList.push({});
    },

    loadWorkShopList() {
      this.$RequestUtil.get({
        url: "/api/factoryModel/getWorkShopList",
        // type:'sync',
        params: { isResource: 1 },
        success: (res) => {
          if (res.code == 0) {
            this.workershopList = res.data;
          } else {
            this.$message.error(res.msg || res.message);
          }
        },
      });
    },

    startProduction(rowDate) {
      if (!rowDate.factoryModelId) {
        this.$message.error("机组不能为空,请选择机组!");
        return;
      }
      let find = rowDate.tecList.find((item) => item.id == rowDate.technologyId) || {};
      if (find.hasProcedure && find.hasProcedure == -1) {
        this.$message.error("工艺路线未审核,请重新选择!");
        return;
      }
      let fun = () => {
        this.$RequestUtil.post({
          url: "/api/productionPlan/startProduction",
          type: "sync",
          params: {
            splitId: rowDate.id,
            productionType: rowDate.productionType,
            tecId: rowDate.technologyId,
          },
          success: (res) => {
            if (res.code == 0) {
              this.search(this.page.currentPage);
              this.$message.success("生产下达成功");
            } else {
              this.$message.error(res.msg || res.message);
            }
          },
        });
      };
      if (rowDate.splitPlanType === 0 && rowDate.splitStatus == 1) {
        this.$confirm(`该工单进行过任务编排，该操作会将编排内容清零，是否继续?`, "提示", {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          fun();
        });
      } else {
        fun();
      }
    },

    processDispatch(rowDate) {
      let find = rowDate.tecList.find((item) => item.id == rowDate.technologyId) || {};
      if (find.hasProcedure && find.hasProcedure == -1) {
        this.$message.error("工艺路线未审核,请重新选择!");
        return;
      }
      this.$RequestUtil.post({
        url: "/api/productionPlan/processDispatching",
        type: "sync",
        params: {
          splitId: rowDate.id,
          productionType: rowDate.productionType,
          tecId: rowDate.technologyId,
        },
        success: (res) => {
          if (res.code == 0) {
            this.search(this.page.currentPage);
            this.$message.success("任务已下达，请前往派工单模块进行任务编排");
          } else {
            this.$message.error(res.msg || res.message);
          }
        },
      });
    },
    cancelProcessDispatch(rowDate) {
      this.$RequestUtil.post({
        url: "/api/productionPlan/cancelProcessDispatching",
        type: "sync",
        params: {
          splitId: rowDate.id,
          productionType: rowDate.productionType,
          tecId: rowDate.technologyId,
        },
        success: (res) => {
          if (res.code == 0) {
            this.search(this.page.currentPage);
            this.$message.success("取消工序派工成功");
          } else {
            this.$message.error(res.msg || res.message);
          }
        },
      });
    },
    cancelCloseProductionPlan(rowData) {
      this.$RequestUtil.post({
        url: "/api/productionTask/restart",
        type: "sync",
        params: {
          splitId: rowData.id,
        },
        success: (res) => {
          if (res.code == 0) {
            this.search(this.page.currentPage);
            this.$message.success("取消关闭成功");
          } else {
            this.$message.error(res.msg || res.message);
          }
        },
      });
    },
  },
  filters: {
    parseName(name) {
      let index = name.lastIndexOf(".");
      let ext = name;
      if (index >= 0) {
        ext = name.substr(0, index);
      }
      return ext;
    },
    formatteTime(item) {
      if (item.planStartTime && item.planEndTime) {
        return (
          CommonUtils.timestampToDate(item.planStartTime, true) +
          " — " +
          CommonUtils.timestampToDate(item.planEndTime, true)
        );
      } else {
        return "";
      }
    },

    formatteMaterialName(value) {
      let str = "";
      switch (value) {
        case 0:
          str = "产品";
          break;
        case 1:
          str = "零件";
          break;
        case 2:
          str = "原材料";
          break;
        default:
          str = "未知类型";
          break;
      }
      return str;
    },

    filterProductionType(value) {
      if (value == 0) {
        return "正常生产";
      } else if (value == 1) {
        return "加急生产";
      } else if (value == 2) {
        return "外购";
      }
    },
  },
  watch: {},
};
</script>

<style scoped>
.is-my-required:before {
  content: "*";
  color: #f56c6c;
  left: 32px;
  top: 6px;
  font-size: 20px;
  position: absolute;
}

.texture.is-my-required:before {
  left: 58px;
}

.is-my-required1:before {
  content: "*";
  color: #f56c6c;
  left: 0px;
  top: 6px;
  font-size: 20px;
  position: relative;
}

.is-my-required2:before {
  content: "*";
  color: #f56c6c;
  left: 0px;
  top: -2px;
  font-size: 20px;
  position: absolute;
}

.span-adaptive {
  display: inline-block;
  width: 128px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.page {
  display: flex;
  justify-content: flex-end;
}

.radius {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin-right: 5px;
  position: relative;
  top: 2px;
}

.total_page {
  margin-top: 20px;
  margin-right: 26px;
  color: #606266;
  font-size: 14px;
}

.delete {
  width: 18px;
  height: 19px;
  background-image: url("/static/img/del.png");
  cursor: pointer;
  background-repeat: no-repeat;
}

.value {
  display: inline-block;
}

.delete:hover {
  background-image: url("/static/img/del-hover.png");
  background-repeat: no-repeat;
}

.search-input-wrap .title11 {
  color: #606266;
  font-family: NotoSansHans-Regula;
  font-size: 14px;
  width: 70px;
  display: inline-block;
  text-align: right;
}

.custome-title {
  display: inline-block;
  width: 98px;
  text-align: right;
  overflow: hidden;
  vertical-align: middle;
  height: 20px;
}

.el-table thead /deep/ tr {
  color: #475569;
  font-weight: 500;
  font-size: 16px;
  font-family: "MiSans-Demibold";
}

.el-table .el-descriptions /deep/ .el-descriptions-item__cell {
  height: 28px !important;
  color: #475569;
  font-size: 16px;
  font-family: "MiSans-Regular";
}

.el-table--small /deep/ td {
  padding: 1px !important;
}

.el-table /deep/ .el-input--small .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
}

.tab-icon {
  font-size: 28px;
  color: #409eff;
  margin-left: 10px;
  cursor: pointer;
  position: relative;
  top: 1px;
}

.line {
  width: calc(100% - 32px);
  border: 2px solid #c0c4cc;
  margin: 10px 20px;
  position: relative;
}

.line::before {
  width: 80px;
  height: 4px;
  display: block;
  position: absolute;
  content: "";
  background: rgb(156, 157, 249);
  top: -2px;
  left: -2px;
}

.file-icon-container {
  width: 100px;
  height: 100px;
  margin-top: 0px;

  background-size: cover;
  position: relative;
  cursor: pointer;
}

.file-delete {
  position: absolute;
  top: -6px;
  right: -2px;
  width: 18px;
  height: 18px;
  background-image: URL("/static/img/delete.png");
  background-size: cover;
  cursor: pointer;
}

.file-name {
  text-align: center;
  display: inline-block;
  width: 100px;
  height: 28px;
  overflow: hidden;
  position: relative;
  top: 5px;
}
</style>

<style>
.file-item .el-form-item__content {
  display: flex;
}

#production-task .el-table tr.el-descriptions-row {
  height: 28px !important;
}

.el-table.cancel-split-table tr {
  height: 48px !important;
}

.el-table .select-row {
  background: #a2a59f;
}

@media screen and (max-width: 1366px) {
  #production-task .search-input-wrap .el-input {
    max-width: 180px !important;
  }

  #production-task .el-input {
    max-width: 100% !important;
  }

  #production-task .add_form .el-input {
    max-width: 100% !important;
  }

  #production-task .add_form .el-date-editor.el-input {
    max-width: 160px !important;
  }

  #production-task .search-input-wrap .el-date-editor.el-input,
  #production-task .search-input-wrap .el-date-editor.el-input__inner {
    width: 190px !important;
  }

  #production-task .el-date-editor.el-input,
  #production-task .el-date-editor.el-input__inner {
    width: auto !important;
  }
}

#production-task .el-descriptions__body {
  background: transparent;
}

#production-task .el-descriptions-row {
  background: transparent;
}

#production-task .el-table__fixed-right {
  padding-bottom: 0px;
}

#production-task .el-descriptions-item__content .el-input__inner {
  color: #000;
  font-size: 14px;
  font-weight: bold;
}

.maxW200 {
  max-width: 200px;
}

.maxW350 {
  max-width: 350px;
}

.width800 {
  max-width: 800px;
  height: 500px;
}

.width800 .el-select-dropdown__wrap {
  max-height: 500px;
}

#production-task .el-form-item__error {
  width: 120%;
}

/* .content-page{
        height: 102%;
    } */
</style>



// WEBPACK FOOTER //
// src/views/order/ProductionTask/index.vue